import React from "react";
import { Button, Container, Row, Col, Form, Card, Tabs, Tab } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from './AppContext';

export default class ItemEditor extends React.Component {
    schemas = {
        BodiesOfWater: [
            { title: 'Name', prop: 'Name', type: 'text' },
            { title: 'Size In Gallons', prop: 'SizeGallons', type: 'text' },
            { title: 'Winterized', prop: 'Winterized', type: 'checkbox' },
        ],
        Devices: [
            { title: 'Name', prop: 'Name', type: 'text' },
            { title: 'Device Type', prop: 'DeviceType', type: 'text' },
            { title: 'Port Type', prop: 'HardwareDevice.Ports.0.Type', type: 'select', options: [
                { value: "HighVoltage", label: "High Voltage" },
                { value: "LowVoltage", label: "Low Voltage" },
                { value: "Thermistor", label: "Thermistor" },
                { value: "Serial", label: "Serial" }
            ] },
            { title: 'UniqueBusIdentifier', prop: 'HardwareDevice.UniqueBusIdentifier', type: 'text' },
            { title: 'Port Number', prop: 'HardwareDevice.Ports.0.Number', type: 'text' },
            { title: 'Chemical Type', prop: 'ChemicalType', type: 'text' },
            { title: 'Make', prop: 'HardwareDevice.Make', type: 'text' },
            { title: 'Model', prop: 'HardwareDevice.Model', type: 'text' },
            { title: 'PrimaryCatalogId', prop: 'HardwareDevice.PrimaryCatalogId', type: 'text' },
            { title: 'SecondaryCatalogId', prop: 'HardwareDevice.SecondaryCatalogId', type: 'text' },
            { title: 'BadCapacitor', prop: 'HardwareDevice.BadCapacitor', type: 'checkbox' },
            { title: 'Serial', prop: 'HardwareDevice.Serial', type: 'text' },
            { title: 'GallonsPerDay', prop: 'HardwareDevice.GallonsPerDay', type: 'text' },
        ],
        nameOnly: [
            { title: 'Name', prop: 'Name', type: 'text' }
        ]
    };

    render() {
        return (
            <div>
                { this.props.record.UUID }
                { 
                    (this.schemas[this.props.schema] || this.schemas.nameOnly).map((field) => {
                        return (
                            <Form.Group key={ this.props.record.UUID + "_" + field.prop }>
                                <Form.Label>{ field.title }</Form.Label>
                                {
                                    field.type === "checkbox" ?
                                    (
                                        <Form.Check
                                            disabled
                                            checked={ context.subGet(this.props.record, field.prop) }
                                        />
                                    )
                                    : 
                                    (
                                        <Form.Control 
                                            type={ "text" }
                                            as={ field.type === "text" ? "input" : field.type }
                                            value={ context.subGet(this.props.record, field.prop) || "" }
                                            onChange={(event) => {
                                                context.subSet(this.props.record, field.prop, event.target.value)
                                                this.setState({});
                                            }}
                                        >
                                            { 
                                                field.options ?
                                                field.options.map(opt => (
                                                    <option key={opt.value} value={ opt.value }>{ opt.label }</option>
                                                ))
                                                : null 
                                            }
                                        </Form.Control >
                                    )
                                }
                            </Form.Group>
                        );
                    })
                }
            </div>
        );
    }
}